module.exports = __webpack_public_path__ + "img/logo.26f5.2f2d74ef.png";